<template>
  <List />
</template>

<script>
import List from "../components/List";

export default {
  components: {
    List,
  },
};
</script>

<style scoped></style>
